import React from 'react'


import '../../css/master.css'
import { useEffect , useState} from 'react'
import {Head} from '../Costants'
import ReactLoading from "react-loading";
import Breadcrumb from '../Breadcrumb/Breadcrumb'


import { useLocation } from "react-router-dom";
import Blog from './Blog';
function BlogMain() {
  const routePath = useLocation();
  const [done, setDone] = useState(undefined);
  useEffect(() => {
    setTimeout(() => {
      setDone(true);
    },3000)
  }, []);


  const onTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    onTop()
  }, [routePath]);
  return (
    <div>
    <Head value = '2'></Head>
    {!done ? (
      <ReactLoading className='hh'
        type={"bars"}
        color={"#541f19"}
        height={400}
        width={100}
      />) : (
        <>
      <Breadcrumb mainheading="BLOG" title_one="BLOG"/>
     <Blog/>
</>
      )}
    </div>
  )
}

export default BlogMain
